// React
import React, { useState, useEffect } from "react";

// Components
import { Card, Nav } from "react-bootstrap";

// View Components
import { ApprovalTab, HistoryTab } from "./components";

const MainApprovalJobMixDesign = ({ setNavbarTitle }) => {
  useEffect(() => {
    setNavbarTitle("Approval Job Mix Design");
    return () => {};
  }, []);

  const [tabs, setTabs] = useState("approval"); //State untuk menampung tabs yang aktif

  // Konfigurasi komponen tabs
  const tabsConfig = [
    {
      tab: "approval",
      label: "Approval",
      component: () => <ApprovalTab />,
    },
    {
      tab: "history",
      label: "History",
      component: () => <HistoryTab />,
    },
  ];

  // Menangani perubahan pada tabs
  const onTabsChangeHandler = (e, newPage) => {
    e.preventDefault();
    setTabs(newPage);
  };

  useEffect(() => {
    setTabs(tabsConfig[0].tab);
  }, []);

  const TabsNav = ({ tab, label }) => (
    <Nav.Item>
      <Nav.Link href={`#${tab}`} onClick={(e) => onTabsChangeHandler(e, tab)}>
        {label}
      </Nav.Link>
    </Nav.Item>
  );

  return (
    <Card>
      <Card.Header>
        <Nav variant="tabs" defaultActiveKey={`#${tabs}`}>
          <TabsNav tab="approval" label="Approval" />
          <TabsNav tab="history" label="History" />
        </Nav>
      </Card.Header>
      <Card.Body>
        {tabs === "approval" ? <ApprovalTab /> : <HistoryTab />}
      </Card.Body>
    </Card>
  );
};

export default MainApprovalJobMixDesign;
